import React, { useState } from "react";
import { Container, Row, Col, Form, Button, Card } from "react-bootstrap";
import {
  handleLoginAction,
  handleLogoutAction,
  handleForgotPassword,
} from "../../store/actions/userActions";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import logo from "../../assets/icons/logo.svg";
import { IMAGES } from "../../constants/constants";
import "../../styles/Dashboard.css";
import "./login.css";
import Cookies from "js-cookie";
import Loader from "../../assets/images/loader.gif";
function ForgotPassword() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.user);
  const [showLogoutButton, setShowLogoutButton] = useState(false);
  const [formData, setFormData] = useState({
    email: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const [logoutuserid, setLogoutUserId] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    const result = await handleForgotPassword(formData, dispatch);
    if (result.isLoading) {
      return (
        <div className="loaderOverlay">
          <img src={Loader} alt="Loader" />
        </div>
      );
    }
    if (result) {
        navigate(`/verify-otp/${formData.email}`);
      setFormData({ email: "" });
    } else {
      // console.error("Login failed");

      if (result.error === "ALREADY LOGGED IN ON SOME OTHER DEVICE") {
        setLogoutUserId(result.userId); // Set the userId in state
        setShowLogoutButton(true);
      }
    }
  };

  const handleLogout = async () => {

    if (!logoutuserid) return;
    const result = await handleLogoutAction(logoutuserid, dispatch);
    if (result) {
      // Clear the auth token from cookies
      Cookies.remove("auth-token");
      setLogoutUserId("");
      setShowLogoutButton(false);
      navigate("/");
    } else {
      // console.error("Logout failed");
    }
  };

  return (
    <Container
      fluid
      className="d-flex align-items-center justify-content-center"
      style={{ minHeight: "100vh", backgroundColor: "#f8f9fa" }}
    >
      <Card className="auth-card">
        <Row className="g-0">
          {/* Left Section - Login Form */}
          <Col md={6}>
            <Card.Body className="d-flex flex-column auth-form-body">
              <div className="mb-4 auth-form-logo">
                <img src={logo} alt="logo" />
              </div>
              <p>Forgot Password</p>
              <p>Enter your email address and we will send you a reset your password.</p>
              <Form onSubmit={handleSubmit}>
                <Form.Group className="mb-3" controlId="formEmail">
                  <Form.Label className="auth-form-label">
                    Email<span>*</span>
                  </Form.Label>
                  <Form.Control
                    className="auth-form-input"
                    type="email"
                    placeholder="Enter email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                  />
                </Form.Group>

                
                {/* <Form.Group className="auth-form-CheckForgot">
                  
                  <a href="/" className="forgot-password">
                    Login?
                  </a>
                </Form.Group> */}

     <Button
                        type="submit"
                        className="w-100 auth-form-btn"
                        style={{ backgroundColor: "#56934e", border: "#56934e" }}
                      >
                        Get OTP
                      </Button>
              </Form>
            </Card.Body>
          </Col>

          {/* Right Section - Static Image */}
          <Col
            md={6}
            className="d-flex justify-content-center align-items-center"
          >
            <div
              className="h-100 w-100"
              style={{
                backgroundImage: `url(${IMAGES.loginFormImage})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                borderRadius: "0 15px 15px 0",
              }}
            ></div>
          </Col>
        </Row>
      </Card>
    </Container>
  );
}

export default ForgotPassword;
